export const projects = [
  {
    'id': 1,
    'name': "Shelfmade",
    "desc": 'A shopping cart with a checkout system',
    'site': 'http://shelfmade.netlify.app',
    'img': require('../utils/imgs/shelf.png'),
    'github': "http://github.com/dglitxh/Shelfmade",
    'stack': ["react", "redux", "firebase", "chakra-ui", "tailwind"]
  },
  {
    'id': 2,
    "name": 'Resumaker',
    "desc": 'An app to create and print out resumes in a blink',
    'site': 'http://resumakers.netlify.app',
    'img':require('../utils/imgs/resumaker.png'),
    'github': "http://github.com/dglitxh/CV-gen",
    'stack': ["react", "ant design", "framer motion", "tailwind"]
  },
  {
    'id': 3,
    "name": 'IceBlog API',
    "desc": 'A blog Api made with django rest framework',
    'site': 'http://iyceblog.herokuapp.com',
    'img':require('../utils/imgs/iceblog.png'),
    'github': "http://github.com/dglitxh/Blog-Api",
    'stack': ['django', 'django-rest-framework', 'swagger', "dj-rest-auth"]
  },
  {
    'id': 4,
    "name": 'BlueHut',
    "desc": 'A landing page for a burgeoning engineering firm',
    'site': 'http://bluehutengineering.netlify.app',
    'img':require('../utils/imgs/iceblog.png'),
    'github': "http://github.com/dglitxh/Bluehut",
    'stack': ["react", "framer motion", "tailwind"]
  },
  {
    'id': 5,
    "name": 'Patiently',
    "desc": 'A rest api to store medical recods',
    'site': "",
    'img':require('../utils/imgs/iceblog.png'),
    'github': "http://github.com/dglitxh/Patiently",
    'stack': ["go", "gin", "docker", "postgresql", "redis"]
  },

]
